var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4527",
    "data-name": "Grupo 4527",
    transform: "translate(-198 -324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seguro",
    transform: "translate(222 347.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5043",
    "data-name": "Grupo 5043",
    transform: "translate(-12 -13.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3598",
    "data-name": "Trazado 3598",
    d: "M23.5,4.237a45.2,45.2,0,0,1,.5,6.585A17.314,17.314,0,0,1,12.539,27.379a2.367,2.367,0,0,1-.54.092,2.077,2.077,0,0,1-.54-.092C9.523,26.655,0,22.6,0,10.822A46.124,46.124,0,0,1,.632,3.244a1.638,1.638,0,0,1,.675-1.036C2.3,1.533,5.28,0,12,0s9.7,1.533,10.688,2.207a.836.836,0,0,1,.313.27l-1.717.767c-1.171-.589-3.924-1.625-9.29-1.625-6.352.006-9.014,1.447-9.737,1.9a47.733,47.733,0,0,0-.589,7.26A15.764,15.764,0,0,0,12.043,25.8,15.8,15.8,0,0,0,22.375,10.78a41.2,41.2,0,0,0-.4-5.819Z",
    fill: "#1a1446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3599",
    "data-name": "Trazado 3599",
    d: "M22.808,17.6l-5.055,6.573v.044l-1.234,1.6-4.766-3.62,1.234-1.605,3.167,2.386,5.055-6.617Z",
    transform: "translate(-5.281 -7.349)",
    fill: "#1a1446"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldBlue);
export default __webpack_public_path__ + "static/media/shieldBlue.d199f3ff4cc2b670d7ca0605139c2dac.svg";
export { ForwardRef as ReactComponent };